import services from './../../../services/service'; // Service Class
import validation from './../../../services/validation'; // Service Class
import Commons from '../../../resources/commons.js'; //Commons class
import MainHeader from './../../MainHeader/index.vue'; // Main Header
import MainFooter from './../../MainFooter/index.vue'; // Main Footer
import AccountDropMenu from '../../../components/templates/account-menu.vue' //
// import Orders from './../../Orderpoint/Orders/index.vue'; //Your Orders
// import Collections from './../../Collections/index.vue'; //Your Orders
// import GiftCards from './../../GiftCards/index.vue'; //Your Gift cards
// import ChatRoom from '../../../components/templates/chat/index.vue'; //Your Chat
// import PaymentService from './../../PaymentService/index.vue'; //Payment service
// import ProductItemForm from '../../../components/product/ProductItemForm.vue' //
// 
//
//import BusinessView from '../Sellpoint' //BusinessView

import commonfunctions from "./commonfunctions";
let service = new services();
let validator = new validation();

// import {
    
// } from '../../../store/mutation-types'

// import {
//     businessActions
// } from '../../../store/actions'

export default {
    name: 'Account',
    mixins: [Commons,commonfunctions],
    data () {
        return {
            //defaults
            kip:0,
            user: {},
            sellpoints:{},
            sellpoint:{},
            business:{}, //binds to sellpoints
            products:{},
            product:{},
            product_item_group:{},
            product_item:{},
            categories:{},
            category:{},
            main_category:{},
            sub_categories:[],
            category_type_1: false,
            category_type_2: false,
            category_type_3: false,
            sellpoint_gallery:{},
            galleria:{},
            lookbooks:{},
            lookbook:{},
            lookbook_post:{},
            menu_view:{},
            menu_tab_view:{},
            menu_tab_inner_view:{},
            is_view:"",
            is_viewing:"Account",
            is_viewed: "Account",
            is_view_type: "Account",
            img_url: service.imageURL,
            server_query_done:false,
            setPanel: false,
            loading:true,
            action_loading:false,
            disable_btn:false,
            data_processing_message:"",
            data_error_message:"",
            data_success_message:"",
            data_media_error_message:"",
            max_media_info:service.max_upload_image_info,
            max_plan_lookbooks:0,
            max_plan_lookbook_posts:0,
            total_lookbooks_added:0,
            can_add_more_lookbook:false,
            can_add_product_lookbook:false,
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            setSettings:false,
            setting_details:{},
            //.../defaults

            //more settings
            states:{},
            cities:{},
            dvco_cities:{},
            delivery_partners:{},
            delivery_option:{},
            other_delivery_option:false,
            edit_other_delivery_option:false,
            custom_delivery_option:false,
            set_dvco_delivery_option:false,
            delivery_custom_options:{},
            component_view:{viewProducts:true,viewProduct:false,viewLookbooks:true,viewLookbook:false,viewLookbookPost:false,},
            business_details:{delivery_edit:false,delivery_add:false,delivery_option_edit:false,viewDiscounts:true,setDiscount:false},
            product_details:{},
            lookbook_details:{},
            manageList:["manageBusinesses","manageProducts","manageServices","manageLookbooks"],
            manage:["manageBusinesses","manageProducts","manageServices","manageLookbooks"],
            discount_coupon:{},
            discount_coupon_is_gift_card: false,
            discount_coupon_is_direct: false,
            managePanel:false,
            manageBusinesses:true, //default view
            manageProducts:false,
            manageServices:false,
            manageLookbooks:false,
            managePosts:false,
            manageOrders:false,
            manageBusinessDetails:false,
            businessComponents: ["BusinessEditing","BusinessDeliveryShipping","BusinessCoupons","BusinessPaymentGateway"],
            business_set_shipping_fee_status:9,
            addDeliveryInformation:false,
            editDeliveryInformation:false,
            product_set_shipping_fee_status:12,
            set_shipping_fee_status_track:false,

            //business settings
            business_agent:0,
            business_open_agents_products:{},
            business_product_categories:[],
            business_service_categories:[],
            business_category_type:0,
            validate_user_name_error:false,
            validate_user_name_message:"",
            
            //product settings
            product_display_image:{},
            product_item:{},
            file_info: {},
            files_info:[], //muttiple files
            imageForm: "",
            imagesFormArray: [], //multiple files
            is_product_service: "product",
            max_upload: service.max_media_upload,
            
            
            //productitems settings
            show_product_setting_box:false,
            // showProductItemGroups: true,
            showProductItemGroups:"",
            tap_01:0,
            //...more--settings

            //loobook settings
            viewing_lookbook: {}, //store viewing lookbook for product swich
            viewing_lookbook_post:{},
            is_viewing_lookbook: false,

            //posts settings
            post:{},
            posts:{},
            viewPost:false,

            //groups
            group:{},
            groups:{},
            view_group_members:false,
            share_group: false,

            //core confirmed settings
            current_sellpoint_id:0,
            market_groups: {},
            app_orders:{},
            order:{},
            viewOrder:false,
            viewPendingPayOrder:false,
            viewPendingPayOrders:false,
            sellpoint_orders:{},
            sellpoint_pending_orders:{},
            sellpoint_transactions:{},
            processing_fee:{},
            //payment gateways
            payment_gateways:{}, 
            ravepay_bank_list:{},
            ravepay_sba:{}, //ravepay_subaccount

            //
            set_reward_type_amount_type:"C", //default
            product_is_wholesale:false,
            prdItemPriceKey:0,
            prdItemWholesaleKey:0,
            //keys
            businessComponentKey:1,
            orderComponentKey:1,
            productVariationComponentKey:1,
            productOrdersComponentKey:1,
            attachProductsComponentKey:1,
            deliveryAddByDcoKey:1,

            //settings
            user_settings:{},

            //agentsco
            broker_deal:{},
            broker_request:{},
            broker_deals:{},
            broker_requests:{},

            //
            market_circle:{},
            subscriptions:{},
            subscribers:{},
            set_sub_view: 'subscriptions',

            //
            set_order_pending_payment_data:"",
            set_pending_payment_data:{},

            //services-more
            service_duration:"",
            service_offers:[],
            service_offer:{},

            //utilities
            data_call_to_actions:{},
            data_components_services:{},

            //
            component_loading:{},

            //
            set_menu:  false,
            menu_link:{},
            back_link_view: 1, //default
            prev_menu_link: '',
            current_menu_link: '',
            prev_menu_tab_view: '',
            current_menu_tab_view: '',
            customers: {},
            reco_products:{},
            has_sellpoints: true,
            productAddView02ComponentKey:0,
            active_group:{},
            ///
            saved_shops:[],
        }
    },

    components: {
        // 'component-header': MainHeader,
        'component-footer': MainFooter,
        'component-account-menu': AccountDropMenu,
    },
    
    methods: {

        toggleMenu(){
            if(this.set_menu == false){
                this.set_menu = true;
            }else if(this.set_menu == true){
                this.set_menu = false;
            }
        },

        presetDEPRAC() {
            this.loading = true;
            let self = this;
            this.user = this.$store.getters['account/getUser'];
            //console.log(899); console.log(this.user)
            if((this.user == undefined) || (Object.keys(this.user).length == 0)){
                localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
                    if(value != undefined) {
                        //self.user.user_id = value.user_id;
                        self.user = value;
                        //special case for profile
                        self.setUser(self.user.user_id);
                        //../special case for profile
                        self.loading = false;
                    }else {
                        // self.$router.push('login');
                        //check if an active dynamic request was sent here 
                        localforage.getItem(service.adr_db_name, function(err, value) { //quick with the callback version
                            if(value != undefined) {
                                self.redir = value.link;
                            }else {
                                //else create new one
                                //activate dynamic request
                                var request_data = {
                                    "name": "Account", //use route component name
                                    "link": "/account",
                                    "dir": "/account",
                                    "src": "/account",
                                    "msg": "Login to manage your account",
                                    "track": 1, //created//started
                                }
                                localforage.setItem(service.adr_db_name, request_data).then(function (value) {
                                }).catch(function(err) {});
                            }
                            //then redirect to login
                            self.$router.push('/login');
                        });
                        //self.$router.push('/login');
                    }
                });
            }else{
                if(Object.keys(this.user).length > 0){
                    this.loading = false;
                    this.setUserDetails();
                }else{
                    this.$router.push('/login');
                }
            }
        },

        setUserDEPRAC(user_id){
            this.$store.dispatch('account/setUserData',user_id);
            //wait and call getUSer
            // this.getUser();
            let self = this;
            setTimeout(function(){ self.getUser(); }, 3000); //wait for 3sec 
        },

        getUserDEPRAC(){
            //this.user = this.$store.getters['account/getUser'];
            // if((this.user.user_email != undefined) && (this.user.user_id > 0)){
            if(this.loadUser){
                if(this.user.user_id > 0){
                    this.setUserBusinesses();
                }else{}
            }
        },

        setUserDetailsDEPRAC(){
            //user businesses
            this.setUserBusinesses();
        },

        setUserBusinessesDEPRAC(){
            if(this.user.user_id > 0){
                this.$store.dispatch('account/userAccountBusinesses',this.user.user_id);
                let self = this;
                setTimeout(function(){ self.getUserBusinesses(); }, 1000); //wait for 3sec 
            }
        },

        getUserBusinessesDEPRAC(){
            //get sps
            this.sellpoints = this.$store.getters['account/getUserBusinesses'];
            //assign 1
            if((this.sellpoints != null) && (Object.keys(this.sellpoints).length > 0)){
                //this.$store.dispatch('account/userAccountBusiness',this.sellpoints[0]);
                ////this.$store.dispatch('account/setBusiness',this.sellpoints[0].business_username);
                this.storeSetBusiness('',0); //0-use 0 here in a case a business exist in store
                this.loading = false
            }
        },

        //

        //--business-app-subscription
        // getAppBusinessSubscription(){
        //     console.log(2111233424222);console.log('offer_set_12');
        //     var payload = {
        //         sub_type: 2, //subscribed to
        //         subscriber_module: 3,//business
        //         subscriber_module_id: this.sellpoint.business_id,
        //     }
        //     service.getAppSubscriptions(this, payload).then(response => {
        //         if(response.body.status == 200) {
        //             this.business_app_subscription = response.body.data[0];
        //            //get the subscription service offering
        //             this.getAppBusinessSubscriptionOffers();
        //         }
        //     }).catch((err) => {})
        // },
        // getAppBusinessSubscriptionOffers(){
        //     //get the subscribed product_item_id of the current subscription
        //     let item_id = 0; let app_id = 0;
        //     // if(Object.keys(this.business_app_subscription).length > 0){
        //         app_id = this.business_app_subscription.subscription_module_id;
        //         item_id = this.business_app_subscription.subscription_active_subscription.subscription_product_service;
        //         if(item_id && (item_id > 0)){
        //             var payload = {
        //                 subscriber_module: 3,//business
        //                 subscriber_module_id: this.sellpoint.business_id,
        //                 subscribed_to_business: app_id,
        //                 subscribed_to_product_service: item_id,
        //                 subscribed_to_service_offers: [5,6], //nos-products,posts
        //             }
        //             service.getAppSubscriptionOffers(this, payload).then(response => {
        //                 if(response.body.status == 200) {
        //                     //dispatch
        //                     this.$store.dispatch('account/setSellpointAppSubscriptionOffers',response.body.data);
        //                     //set
        //                     this.business_app_subscription_offers = response.body.data;
        //                     // for(let offer of this.business_app_subscription_offers){
        //                     //     if(offer.service_offer == 5){
        //                     //         this.subscription_offer.products = offer;
        //                     //     }
        //                     //     if(offer.service_offer == 6){
        //                     //         this.subscription_offer.posts = offer;
        //                     //     }
        //                     // }
        //                 }
        //             }).catch((err) => { })
        //         }
        //     //}
        // },

        // setAppBusinessSubscriptionOffers(service_offer){
        //     let offer_set = this.$store.getters['account/getSellpointAppSubscriptionOffers'];console.log('offer_set');console.log(offer_set)
        //     this.business_app_subscription_offers = offer_set;
        //     for(let offer of this.business_app_subscription_offers){
        //         if(offer.service_offer == service_offer){
        //            return offer;
        //         }
        //     }
        // },
    },

    mounted: function(){

    },
   

    created: function(){ 
        this.loadAccountBase();
        //this.preset();
      //this.getUserBusinesses();
    }
}


// WEBPACK FOOTER //
// ./src/pages/Account/Resources/script.js